module.exports = __webpack_public_path__ + "img/score-icon-8.f89a41b2.png";